/* eslint-disable @typescript-eslint/no-require-imports */
function loadEnv() {
  if (!process.env.NEXT_PUBLIC_SANITY_DATASET) {
    try {
      require('dotenv').config({
        path: require('path').resolve(__dirname, '../../.env.local'),
      });
      console.log('🔧 Loaded env vars manually');
    } catch (err) {
      console.warn('❌ Failed to load dotenv:', err);
    }
  }
}

loadEnv();

// Define types for environment variables
const store = {
  dataset: process.env.NEXT_PUBLIC_SANITY_DATASET || '',
  projectId: process.env.NEXT_PUBLIC_SANITY_PROJECT_ID || '',
  apiVersion: '2023-05-23',
  useCdn: true,

  token: process.env.NEXT_PUBLIC_SANITY_TOKEN,
  isAdsEnable: process.env.NEXT_PUBLIC_ENABLE_ADS === 'true' || false,

  // AI Model Configuration with fallbacks
  defaultGoogleModel: process.env.NEXT_PUBLIC_GOOGLE_AI_MODEL || 'gemini-1.5-flash-latest',
  defaultOpenaiModel: process.env.NEXT_PUBLIC_OPENAI_API_MODEL || 'gpt-3.5-turbo',

  // Default AI Parameters (can be overridden by specific calls)
  // Ensure your .env values are parseable to numbers if set
  defaultTemperature: process.env.NEXT_PUBLIC_DEFAULT_AI_TEMPERATURE
    ? parseFloat(process.env.NEXT_PUBLIC_DEFAULT_AI_TEMPERATURE)
    : undefined, // Example: 0.7. Undefined means use provider's default.
  defaultMaxTokens: process.env.NEXT_PUBLIC_DEFAULT_AI_MAX_TOKENS
    ? parseInt(process.env.NEXT_PUBLIC_DEFAULT_AI_MAX_TOKENS, 10)
    : undefined, // Example: 2048. Undefined means use provider's default.

  // Admin Credentials (dummy for now)
  adminEmail: 'admin@gmail.com',
  adminPassword: '123456', // In a real app, use env vars and hashed passwords!
};

export default store;
